import React from "react";
import { Table, Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./premium.css";

const { Option } = Select;

const CustomTable = ({
  title,
  columns,
  data,
  pageSize,
  setPageSize,
  onSearch,
}) => {
  return (
    <div className="premium-wrapper">
      <div className="premium-card">

        {/* Header */}
        <div className="table-header">
          <h4>{title}</h4>
          <p className="subtitle">Manage and track your records</p>
        </div>

        {/* Controls */}
        <div className="table-controls">
          <div className="left">
            <span>Rows</span>
            <Select
              value={pageSize}
              className="custom-select"
              onChange={setPageSize}
            >
              <Option value={5}>5</Option>
              <Option value={10}>10</Option>
              <Option value={20}>20</Option>
            </Select>
          </div>

          <Input
            placeholder="Search anything..."
            prefix={<SearchOutlined />}
            className="custom-search"
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>

        {/* Table */}
        <div className="table-container">
          <Table
            columns={columns}
            dataSource={data}
            pagination={{ pageSize }}
            rowKey="id"
          />
        </div>
      </div>
    </div>
  );
};

export default CustomTable;